/**
 * @generated SignedSource<<391c7f4a1c7392cbd1880ce1df1b772c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteFeatureFlagCohortInput = {
  cohortId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteFeatureFlagCohortMutation$variables = {
  input: DeleteFeatureFlagCohortInput;
};
export type deleteFeatureFlagCohortMutation$data = {
  readonly DeleteFeatureFlagCohort: {
    readonly missionControlData: {
      readonly id: string;
      readonly featureFlagLists: {
        readonly id: string;
        readonly cohorts: ReadonlyArray<{
          readonly id: string;
          readonly cohortId: number | null;
          readonly name: string | null;
          readonly companyIds: ReadonlyArray<number | null> | null;
        } | null> | null;
        readonly alwaysLastCompanyIds: ReadonlyArray<number | null> | null;
      } | null;
    } | null;
  } | null;
};
export type deleteFeatureFlagCohortMutation = {
  variables: deleteFeatureFlagCohortMutation$variables;
  response: deleteFeatureFlagCohortMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFeatureFlagCohortPayload",
    "kind": "LinkedField",
    "name": "DeleteFeatureFlagCohort",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlDataType",
        "kind": "LinkedField",
        "name": "missionControlData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlFeatureFlagListsType",
            "kind": "LinkedField",
            "name": "featureFlagLists",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlFeatureFlagCohortType",
                "kind": "LinkedField",
                "name": "cohorts",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cohortId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alwaysLastCompanyIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFeatureFlagCohortMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFeatureFlagCohortMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "012b59896c705f50073737fe69a2f021",
    "id": null,
    "metadata": {},
    "name": "deleteFeatureFlagCohortMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFeatureFlagCohortMutation(\n  $input: DeleteFeatureFlagCohortInput!\n) {\n  DeleteFeatureFlagCohort(input: $input) {\n    missionControlData {\n      id\n      featureFlagLists {\n        id\n        cohorts {\n          id\n          cohortId\n          name\n          companyIds\n        }\n        alwaysLastCompanyIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36d90986ead5ef8f5cbc2385d95504a0";

export default node;
